import React, { useState } from 'react';
import ForgotPasswordRequestOtp from './ForgotPasswordRequestOtp';
import ForgotPasswordVerifyOtp from './ForgotPasswordVerifyOtp';
import ForgotPasswordReset from './ForgotPasswordReset';

interface ForgotPasswordProps {
  onBackToLogin: () => void;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ onBackToLogin }) => {
  const [step, setStep] = useState<'request' | 'verify' | 'reset'>('request');
  const [email, setEmail] = useState('');
  const [resetToken, setResetToken] = useState('');

  const handleOtpSent = (emailAddress: string) => {
    setEmail(emailAddress);
    setStep('verify');
  };

  const handleOtpVerified = (token: string) => {
    setResetToken(token);
    setStep('reset');
  };

  const handlePasswordReset = () => {
    onBackToLogin();
  };

  const handleBackToRequest = () => {
    setStep('request');
    setEmail('');
    setResetToken('');
  };

  const handleBackToVerify = () => {
    setStep('verify');
    setResetToken('');
  };

  if (step === 'request') {
    return <ForgotPasswordRequestOtp onOtpSent={handleOtpSent} onBack={onBackToLogin} />;
  }

  if (step === 'verify') {
    return <ForgotPasswordVerifyOtp email={email} onOtpVerified={handleOtpVerified} onBack={handleBackToRequest} />;
  }

  return <ForgotPasswordReset email={email} resetToken={resetToken} onPasswordReset={handlePasswordReset} onBack={handleBackToVerify} />;
};

export default ForgotPassword;

